import { apiSliceDev } from "features/api/fetchBaseQuery";

const apiSlices = {
  dev: apiSliceDev,
};

export const getApiSLice = (enviornment: string) => {
  return apiSlices[enviornment];
};
